export default __webpack_public_path__ + "static/media/add_manual_in_app.cc061465.png";